<template>
  <navBack></navBack>
  <div class="page">
  
      <div class="weui-tab">
        <div class="weui-navbar2">
          <block v-for="(item, index) in tabs" :key="index">
            <div 
              @click="clickThis(index)"
              class="weui-navbar__item2"
              :class="{ 'weui-bar__item_on2': activeIndex === index }"
            >
              {{ item }}
            </div>
          </block>
        </div>
      </div>
      
      <div class="weui-tab__panel tab0" v-if="activeIndex === 0">
        <block v-for="(item, index) in couponListOn" :key="index">
          <coupon-bar :coupon="item.couponInfo">
            <t-button 
              size="small" 
              :theme="chosedCouponInfo._id === item._id ? 'primary' : 'default'"
              style="color: black; font-weight: normal;"
              @click="useThisCoupon(index)"
            >
              使用
            </t-button>
          </coupon-bar>
        </block>
      </div>

      <div class="weui-tab__panel tab1" v-if="activeIndex === 1">
        <block v-for="(item, index) in couponListOff" :key="index">
          <coupon-bar :coupon="item.couponInfo" />
        </block>
      </div>
    </div>
 
</template>

<script setup>
import { ref, onMounted } from 'vue'
import navBack  from '@/components/nav-back.vue'
 
// 响应式数据
const activeIndex = ref(0)
const tabs = ref(['可使用', '不可使用'])
const couponListOn = ref([])
const couponListOff = ref([])
const chosedCouponInfo = ref({})

// 点击标签页
const clickThis = (index) => {
  activeIndex.value = index
}

// 使用优惠券
const useThisCoupon = (index) => {
  const coupon = couponListOn.value[index]
  chosedCouponInfo.value = coupon
  // 处理使用优惠券逻辑
  console.log('使用优惠券:', coupon)
}

// 加载优惠券列表
const loadCouponList = async () => {
  try {
    // 这里应该调用实际的API获取优惠券数据
    // 示例数据
    couponListOn.value = [
      {
        _id: '1',
        couponInfo: {
          name: '满减券',
          amount: 50,
          condition: '满200可用'
        }
      }
    ]
    
    couponListOff.value = [
      {
        _id: '2',
        couponInfo: {
          name: '折扣券',
          discount: 0.9,
          condition: '全场通用'
        }
      }
    ]
  } catch (error) {
    console.error('加载优惠券列表失败:', error)
  }
}

// 组件挂载时加载数据
onMounted(() => {
  loadCouponList()
})
</script>

<style scoped>
 

.page {
  height: 100%;
}

.weui-tab {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.weui-navbar2 {
  display: flex;
  background-color: #fafafa;
  position: relative;
}

.weui-navbar__item2 {
  flex: 1;
  text-align: center;
  padding: 20rpx 0;
  font-size: 28px;
  color: #666;
}

.weui-navbar__item2.weui-bar__item_on2 {
  color: #007aff;
  border-bottom: 4rpx solid #007aff;
}

.weui-tab__panel {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

.tab0, .tab1 {
  height: calc(100% - 80rpx);
}
</style>